<template>
  <v-form>
    <validation-provider
      v-slot="{ errors }"
      :rules="validations.username"
      slim
      name="username"
    >
      <v-text-field
        v-model="user.username"
        label="Username"
        name="username"
        :error-messages="errors"
        type="text"
      >
      </v-text-field>
    </validation-provider>

    <validation-provider
      v-slot="{ errors }"
      :rules="validations.password"
      slim
      vid="password"
      name="password"
    >
      <v-text-field
        v-model="user.password"
        label="Password"
        name="password"
        :error-messages="errors"
        type="password"
      >
      </v-text-field>
    </validation-provider>

    <validation-provider
      v-slot="{ errors }"
      :rules="validations.passwordConfirmation"
      slim
      name="passwordConfirmation"
    >
      <v-text-field
        v-model="user.passwordConfirmation"
        label="Password Confirmation"
        name="passwordConfirmation"
        :error-messages="errors"
        type="password"
      >
      </v-text-field>
    </validation-provider>

    <validation-provider v-slot="{ errors }" slim name="active">
      <v-switch
        v-model="user.active"
        label="Active"
        name="active"
        :error-messages="errors"
      >
      </v-switch>
    </validation-provider>
  </v-form>
</template>

<script>
import { ValidationProvider, extend } from "vee-validate";
import { required, confirmed, oneOf } from "vee-validate/dist/rules.js";

extend("required", {
  ...required,
  message: "This field is required"
});

extend("confirmed", {
  ...confirmed,
  message(field, params) {
    return `${field} mut be the same as ${params.target}`;
  }
});

extend("oneOf", oneOf);

export default {
  name: "UserForm",
  components: {
    ValidationProvider
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    validations: {
      type: Object,
      required: true
    }
  }
};
</script>
